import React from 'react';
import './CandidateCardHeading.css';

const COUNTRY_ISO = {
  bangladesh: 'bd',
  bahrain: 'bh',
  burundi: 'bi',
  cambodia: 'kh',
  ethiopia: 'et',
  ghana: 'gh',
  india: 'in',
  indonesia: 'id',
  kenya: 'ke',
  kuwait: 'kw',
  nepal: 'np',
  oman: 'om',
  pakistan: 'pk',
  philippines: 'ph',
  qatar: 'qa',
  saudi: 'sa',
  'saudi arabia': 'sa',
  'sierra leone': 'sl',
  'sri lanka': 'lk',
  srilanka: 'lk',
  tanzania: 'tz',
  thailand: 'th',
  uae: 'ae',
  'united arab emirates': 'ae',
  uganda: 'ug',
  vietnam: 'vn',
};

const normalizeCountry = (country) =>
  String(country || '')
    .trim()
    .replace(/\s+/g, ' ');

const getCountryIso = (country) => {
  const normalized = normalizeCountry(country).toLowerCase();
  return COUNTRY_ISO[normalized] || null;
};

const formatName = (name, fallback = 'Candidate') => {
  const rawName = String(name || '').split('@')[0].trim();
  if (!rawName) return fallback;

  const firstName = rawName.split(/\s+/)[0] || fallback;
  return firstName.charAt(0).toUpperCase() + firstName.slice(1);
};

const formatJobPosition = (jobPosition) => {
  if (Array.isArray(jobPosition)) {
    return jobPosition.join(', ').trim();
  }

  return String(jobPosition || '').trim();
};

const formatGender = (gender) => {
  const normalizedGender = String(gender || '').trim();
  if (!normalizedGender || normalizedGender.toLowerCase() === 'not specified') {
    return '';
  }

  return normalizedGender.charAt(0).toUpperCase() + normalizedGender.slice(1);
};

function CandidateCardHeading({
  candidate = {},
  prefix = '',
  className = '',
  primaryValue,
  primaryLabel = '',
  showGender = true,
}) {
  const name = formatName(candidate.first_name || candidate.name || candidate.full_name);
  const jobPosition = formatJobPosition(candidate.job_position);
  const displayPrimaryValue = primaryValue || jobPosition || name;
  const gender = showGender ? formatGender(candidate.gender) : '';
  const age = candidate.age || candidate.candidate_age || '';
  const country = normalizeCountry(candidate.nationality || candidate.country || candidate.current_country);
  const countryIso = getCountryIso(country);

  return (
    <div className={`candidate-card-heading ${className}`.trim()}>
      <span className="candidate-card-heading-item">
        {primaryLabel && (
          <span className="candidate-card-heading-label">{primaryLabel}</span>
        )}
        <span className="candidate-card-heading-value">
          {prefix}{displayPrimaryValue}
        </span>
      </span>

      {gender && (
        <>
          <span className="candidate-card-heading-dot" aria-hidden="true">&bull;</span>
          <span className="candidate-card-heading-gender">{gender}</span>
        </>
      )}

      {age && (
        <>
          <span className="candidate-card-heading-dot" aria-hidden="true">&bull;</span>
          <span className="candidate-card-heading-item">
            <span className="candidate-card-heading-label">Age:</span>
            <span className="candidate-card-heading-value">{age}</span>
          </span>
        </>
      )}

      {country && (
        <>
          <span className="candidate-card-heading-dot" aria-hidden="true">&bull;</span>
          <span className="candidate-card-heading-country">
            {countryIso && (
              <img
                src={`https://flagcdn.com/24x18/${countryIso}.png`}
                srcSet={`https://flagcdn.com/48x36/${countryIso}.png 2x`}
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="candidate-card-heading-flag"
              />
            )}
            <span>{country}</span>
          </span>
        </>
      )}
    </div>
  );
}

export default CandidateCardHeading;
